<template>
  <div class="flex justify-center">
    <div class="overflow-hidden bg-white shadow sm:rounded-md mt-2 sm:mt-12 w-full sm:w-2/3">
      <ul v-if="ratings" role="list" class="divide-y divide-gray-200">
        <li v-for="(rating, idx) in ratings" :key="idx">
          <div class="px-4 py-3 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-left mr-2">{{ rating.question }}</p>
              <div class="ml-2 flex flex-shrink-0">
                <p
                  class="
                    rounded-md
                    bg-gray-300
                    w-14
                    h-10
                    text-md
                    font-semibold
                    leading-5
                    text-gray-500
                    flex
                    items-center
                    justify-center
                  "
                >
                  {{ averageFormatted(rating.average) }}
                </p>
              </div>
            </div>
          </div>
        </li>

        <!-- subtotal: start -->
        <li>
          <div class="px-4 py-3 sm:px-6">
            <div class="flex items-center justify-end">
              <p class="truncate text-sm font-bold mr-4">Zwischensumme <span v-if="resultIdx == 2">x 2</span></p>
              <div class="ml-2 flex flex-shrink-0">
                <p
                  class="
                    rounded-md
                    bg-markencode-blue
                    w-14
                    h-10
                    text-md
                    font-semibold
                    leading-5
                    text-white
                    flex
                    items-center
                    justify-center
                  "
                >
                  {{ averageFormatted(subtotal) }}
                </p>
              </div>
            </div>
          </div>
        </li>
        <!-- subtotal: end -->


        <!-- productivity assessment: start -->
        <li v-if="resultIdx == 2">
          <div class="px-4 py-3 sm:px-6">
            <div class="flex items-center justify-end">
              <p class="truncate text-sm font-bold mr-4">Produktivität in %</p>
              <div class="ml-2 flex flex-shrink-0">
                <p
                  class="
                    rounded-md
                    bg-markencode-blue
                    w-14
                    h-10
                    text-md
                    font-semibold
                    leading-5
                    text-white
                    flex
                    items-center
                    justify-center
                  "
                >
                  {{ averageFormatted(subtotal * 2) }}
                </p>
              </div>
            </div>
          </div>
        </li>
        <!-- productivity assessment: end -->


      </ul>
    </div>
  </div>
</template>

<script>
import { sumBy } from 'lodash';

export default {
  name: 'LiveResultsResult',

  props: ['session', 'translations', 'ratings', 'resultIdx'],

  methods: {
    averageFormatted(average) {
      if(average === null) {
        average = 0;
      }

      return average.toLocaleString('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
  },

  computed: {
    subtotal() {
      return sumBy(this.ratings, 'average');
    },
  },
};
</script>